import { Link } from "react-router-dom";

export const WhatsAppIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413" />
  </svg>
);

const SHOP_LINKS = [
  { to: "/shop", label: "All Sets" },
  { to: "/shop?fabric=Muslin", label: "Muslin" },
  { to: "/shop?fabric=Rayon", label: "Rayon" },
  { to: "/shop?fabric=Crepe", label: "Crepe" },
  { to: "/shop?fabric=Turkish Slub Cotton", label: "Turkish Slub Cotton" },
];

const HELP_LINKS = [
  { to: "/track-order", label: "Track Your Order" },
  { to: "/size-guide", label: "Size Guide" },
  { to: "/shipping-returns", label: "Shipping & Returns" },
  { to: "/contact", label: "Contact Us" },
];

const COMPANY_LINKS = [
  { to: "/about", label: "Our Story" },
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms of Service" },
];

export default function Footer() {
  return (
    <footer className="bg-ink text-white/70">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <img src="/logo.png" alt="Just Kords" className="h-12 w-auto rounded bg-white p-1" />
            <p className="mt-5 max-w-xs font-serif text-2xl italic leading-snug text-white/90">
              Co-ord sets for every mood.
            </p>
            <p className="mt-3 max-w-sm text-sm leading-relaxed">
              Matching kurta-palazzo sets in breathable muslin, rayon and crepe — designed in India, cut to flatter, made to move.
            </p>
          </div>

          {[
            { title: "Shop", links: SHOP_LINKS, id: "footer-shop" },
            { title: "Help", links: HELP_LINKS, id: "footer-help" },
            { title: "Company", links: COMPANY_LINKS, id: "footer-company" },
          ].map((col) => (
            <div key={col.title}>
              <h4 className="font-mono text-[11px] uppercase tracking-[0.3em] text-crimson">{col.title}</h4>
              <ul className="mt-5 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      data-testid={`${col.id}-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                      className="text-sm transition-colors duration-200 hover:text-white"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em]">
            © 2025 Just Kords · justkords.com
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em]">
            UPI · Cards · NetBanking — secured by Razorpay
          </p>
        </div>
      </div>
    </footer>
  );
}
